// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"16":"7bfe9a8b","131":"af764869","641":"8dcf2068","892":"ec3e6dfa","947":"916c771c","957":"037fac16"}[chunkId] + ".css";
};